// Copyright (c) Docugami, Inc. All rights reserved.
import React, { ComponentType, FC } from 'react';
import { UnsupportedPlatformPage } from 'pages/UnsupportedPlatformPage';
import { browser } from '../../..';

const withSupportedPlatformRequired = <P extends object>(
  Component: ComponentType<P>,
): FC<P> => {

  return function WithSupportedPlatformRequired(props: P): JSX.Element {
    const supportedBrowsers = ["chrome", 'edge-chromium'];
    const isChromium = supportedBrowsers.includes(browser.name);
    const screenSizeAcceptable = window.innerWidth > 500;

    return isChromium && screenSizeAcceptable ?
    <Component {...props} /> :
    <UnsupportedPlatformPage {...props}/>;
  };
};

export default withSupportedPlatformRequired;
